import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

export const TableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #171719;
  margin: 0;
`;

export const AddButton = styled.button`
  background-color: #448181;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover:not(:disabled) {
    background-color: #3a6f6f;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const TableContainer = styled.div`
  border-radius: 12px;
  border: 1px solid #e1e2e4;
  overflow: hidden;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;

  thead {
    background-color: rgba(112, 115, 124, 0.05);
  }

  th {
    padding: 16px 20px;
    text-align: left;
    font-weight: 600;
    color: rgba(46, 47, 51, 0.88);
    border-bottom: 1px solid rgba(112, 115, 124, 0.16);
    font-size: 13px;
    letter-spacing: 0.02em;
  }

  th:first-child {
    width: 80px;
  }

  th:last-child {
    width: 150px;
  }

  td {
    padding: 10px 20px;
    border-bottom: 1px solid rgba(112, 115, 124, 0.16);
    color: #171719;
    font-size: 16px;
    line-height: 1.5;
  }

  tbody tr:last-child td {
    border-bottom: none;
  }

  tbody tr:hover {
    background-color: rgba(112, 115, 124, 0.02);
  }

  @media (max-width: 768px) {
    font-size: 12px;

    th,
    td {
      padding: 12px 16px;
    }
  }
`;

export const NoData = styled.td`
  text-align: center;
  color: rgba(55, 56, 60, 0.61);
  font-style: italic;
  padding: 40px 20px;
`;

export const Actions = styled.div`
  display: flex;
  gap: 8px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 4px;
  }
`;

const ActionButton = styled.button`
  border-radius: 8px;
  border: 1px solid rgba(112, 115, 124, 0.16);
  padding: 7px 12px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  background-color: #fff;
  transition: all 0.2s ease;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const EditButton = styled(ActionButton)`
  color: #171719;

  &:hover:not(:disabled) {
    background-color: rgba(112, 115, 124, 0.05);
  }
`;

export const DeleteButton = styled(ActionButton)`
  color: #e52222;

  &:hover:not(:disabled) {
    background-color: rgba(255, 255, 255, 0.9);
    border-color: #448181;
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const Modal = styled.div`
  background-color: #fff;
  border-radius: 12px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);

  @media (max-width: 768px) {
    margin: 16px;
    width: calc(100% - 32px);
  }
`;

export const DeleteModal = styled.div`
  background-color: #fff;
  border-radius: 12px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);

  @media (max-width: 768px) {
    margin: 16px;
    width: calc(100% - 32px);
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 24px 0;
  border-bottom: 1px solid #e1e2e4;
  margin-bottom: 24px;

  h3 {
    font-size: 20px;
    font-weight: 600;
    color: #171719;
    margin: 0;
  }

  @media (max-width: 768px) {
    padding: 20px 20px 0;
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  color: rgba(55, 56, 60, 0.61);
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #171719;
  }
`;

export const ModalContent = styled.div`
  padding: 0 24px;

  @media (max-width: 768px) {
    padding: 0 20px;
  }
`;

export const FormGroup = styled.div`
  margin-bottom: 20px;

  label {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: rgba(46, 47, 51, 0.88);
    margin-bottom: 8px;
  }
`;

export const Input = styled.input`
  width: 100%;
  padding: 12px;
  border: 1px solid rgba(112, 115, 124, 0.16);
  border-radius: 12px;
  font-size: 16px;
  color: #171719;
  background-color: #fff;
  transition: border-color 0.2s ease;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #448181;
    box-shadow: 0 0 0 3px rgba(68, 129, 129, 0.1);
  }

  &::placeholder {
    color: rgba(55, 56, 60, 0.28);
  }
`;

export const ModalActions = styled.div`
  padding: 24px;
  border-top: 1px solid #e1e2e4;
  display: flex;
  gap: 12px;
  justify-content: flex-end;

  @media (max-width: 768px) {
    padding: 20px;
    flex-direction: column;
  }
`;

const ModalButton = styled.button`
  padding: 12px 24px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const CancelButton = styled(ModalButton)`
  border: 1px solid rgba(112, 115, 124, 0.16);
  background-color: #fff;
  color: #171719;

  &:hover:not(:disabled) {
    background-color: rgba(112, 115, 124, 0.05);
  }
`;

export const SaveButton = styled(ModalButton)`
  background-color: #448181;
  color: #fff;
  border: none;

  &:hover:not(:disabled) {
    background-color: #3a6f6f;
  }
`;

export const DeleteModalContent = styled.div`
  padding: 32px 24px 16px;
  text-align: center;

  h3 {
    font-size: 20px;
    font-weight: 600;
    color: #171719;
    margin: 0 0 16px;
  }

  p {
    font-size: 16px;
    color: #171719;
    margin: 0 0 8px;
    line-height: 1.5;
  }
`;

export const Warning = styled.p`
  color: #e52222;
  font-size: 14px;
  margin-top: 8px;
`;

export const DeleteConfirmButton = styled(ModalButton)`
  background-color: #e52222;
  color: #fff;
  border: none;

  &:hover:not(:disabled) {
    background-color: #d01e1e;
  }
`;
